<template>
  <div class="video-lite-delivery">
    <p class="level-1">投放设置</p>

    <delivery :form="form" />

    <div class="ea-container">
      <optimize-target
        :externalActions="externalActions"
        :form="form"
        :top="0"
        cardTitle="预估展现量"
      />
    </div>

    <budget-bit :form="form" budgetTitle="日预算" />

    <div class="audience-container">
      <audience-settings :form="form" />

      <div class="collapse-more" v-show="moreSetting">
        <p class="level-2">投放日期</p>
        <el-radio-group v-model="form.dateType" size="medium">
          <el-radio-button label="从今天起长期投放"></el-radio-button>
          <el-radio-button label="设置开始和结束日期"></el-radio-button>
        </el-radio-group>
        <div class="date" v-show="form.dateType == '设置开始和结束日期'">
          <el-date-picker
            v-model="form.startTime"
            :picker-options="pickerOptions"
            type="date"
            size="small"
            placeholder="请选择日期"
          >
          </el-date-picker>
          —
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptions"
            type="date"
            size="small"
            placeholder="请选择日期"
          >
          </el-date-picker>
        </div>

        <p class="level-2">投放时段</p>
        <el-radio-group v-model="form.timeIntervalType" size="medium">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="指定时间段" disabled></el-radio-button>
        </el-radio-group>
      </div>
      <div class="collapse-header" @click="moreSetting = !moreSetting">
        <i
          class="icon"
          :class="[
            moreSetting ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right',
          ]"
        ></i>
        <span class="text">{{ moreSetting ? "收起" : "展开高级选项" }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AudienceSettings from "../components/audienceSettings.vue";
import BudgetBit from "../components/budgetBit.vue";
import customAudience from "../components/customAudience.vue";
import Delivery from '../components/delivery.vue';
import OptimizeTarget from "../components/optimizeTarget.vue";
export default {
  components: {
    customAudience,
    OptimizeTarget,
    BudgetBit,
    AudienceSettings,
    Delivery,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      externalActions: [
        {
          icon: require("@/assets/images/simulation/icon_cart.svg"),
          name: "商品购买",
          content: "更多人购买商品",
        },
        {
          icon: require("@/assets/images/simulation/icon_fans.svg"),
          name: "粉丝提升",
          content: "更多人关注抖音号",
        },
        {
          icon: require("@/assets/images/simulation/icon_heart.svg"),
          name: "点赞评论",
          content: "更多人点赞或评论",
        },
      ],

      moreSetting: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.video-lite-delivery {
  margin-top: 56px;
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
    .el-icon-question {
      margin-left: 3px;
      color: #d3d3d3;
      font-size: 16px;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .ea-container {
    position: relative;
  }

  .audience-container {
    padding-bottom: 40px;
    .collapse-more {
      .date {
        display: inline-block;
        margin-left: 50px;
        ::v-deep .el-date-editor {
          width: 138px;
          .el-input__inner {
            background-color: #f2f2f2;
          }
        }
      }
    }
    .collapse-header {
      display: inline-block;
      margin-top: 25px;
      cursor: pointer;
      .icon {
        margin-right: 8px;
        transform: rotate(90deg);
        font-weight: bold;
      }
      .text {
        letter-spacing: 2px;
      }
    }
  }

  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
}
</style>